import { apiService } from '../../..'
import { FinaliseThreeDSRequest, InitiateThreeDSRequest, InitiateThreeDSResponse } from '../types'

const baseUrl = '/portal/consumers/threeDS'

export const threeDSService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    initiateThreeDS: build.mutation<InitiateThreeDSResponse, InitiateThreeDSRequest>({
      query: (data) => {
        return {
          url: `${baseUrl}/initiate`,
          method: 'POST',
          data,
        }
      },
    }),
    finaliseThreeDS: build.mutation<void, FinaliseThreeDSRequest>({
      query: (data) => {
        return {
          url: `${baseUrl}/finalise`,
          method: 'POST',
          data,
        }
      },
    }),
  }),
})
